import { render, staticRenderFns } from "./SearchHousing.vue?vue&type=template&id=895ed1f4&"
import script from "./SearchHousing.vue?vue&type=script&lang=js&"
export * from "./SearchHousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports